import { useEffect, useState } from "react";

export const useHandleStation = (data) => {
  const [stations, setStations] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const handleStation = (e, val) => {
    const value = val ? val : '';
    setStations(value);
    const stationsFiltered = data.filter((data) => data.idStation === value.id);
    setFilterData(stationsFiltered);
  };

  useEffect(() => {
    if (stations) {
      const stationsFiltered = data.filter((data) => data.idStation === stations.id);
      setFilterData(stationsFiltered);
    }
  }, [data, stations]);

  return {
    stations, filterData, handleStation
  };
};
